.kv{font-family:inherit;}